import React, { useState, useEffect } from "react";

import {AiOutlineMail} from "react-icons/ai";
import { FaVolumeUp } from "react-icons/fa";
import Guidelines from "@/components/GuideLines";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import PageTopStyle from "@/assets/styles/components/PageTopStyle";
import { SpeechHeaderButtonStyle } from "@/assets/styles/components/SpeechReaderStyle";
import {useQuery} from "react-query";
import {getHomeContact} from "@/api/general";
// swiper
import {Swiper, SwiperSlide} from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import {Autoplay} from "swiper";
import SwiperFlag from "@/components/header/swiper_Flag";
import Mesengers from "@/components/footer/mesengers";
import {Link} from "react-router-dom";
import {t} from "i18next";
import {useTranslation} from "react-i18next";




const PageTop = () => {
    const {t} = useTranslation();
    const [isSpeechActive, setIsSpeechActive] = useState(false);

    useEffect(() => {
        setIsSpeechActive(localStorage.getItem("speech-reader-active") === "true");

        const handleStatusChange = (e) => {
            setIsSpeechActive(e.detail.active);
        };

        window.addEventListener("speech-reader-status-change", handleStatusChange);
        return () => {
            window.removeEventListener("speech-reader-status-change", handleStatusChange);
        };
    }, []);

    const handleToggleSpeech = () => {
        window.dispatchEvent(new CustomEvent("toggle-speech-reader"));
    };

    const {data} = useQuery("contact", getHomeContact);
    return (
        <PageTopStyle>
            <div className="header__top">
                <div className="container">
                    <div className="header__top__icons">
                        <Swiper
                            direction={'vertical'}
                            slidesPerView={1}
                            spaceBetween={1}
                            loop={true}
                            pagination={{
                                clickable: true,
                            }}
                            autoplay={{
                                delay: 3000,
                                disableOnInteraction: false,
                                pauseOnMouseEnter: true,
                                reverseDirection: true,

                            }}
                            modules={[ Autoplay]}
                            className="mySwiper"
                            style={{
                                height:"50px",
                                width:"300px",
                            }}>

                            <SwiperSlide>
                                <SwiperFlag/>
                            </SwiperSlide>
                            <SwiperSlide>
                                <Mesengers/>
                            </SwiperSlide>

                        </Swiper>


                    </div>
                    <ul className={"header__top__list"}>
                        <div className="phoe_and_email">
                            <li className={"header__top__list__item"}>
                                <Link to="/structure/centers/7">
                                    {t("header.header__sub__menu.menu-1.item-7")}
                                </Link>
                            </li>
                            <li className={"header__top__list__item"}>
                                <a target={"_blank"} href={`${data?.data?.data[0].email}`}>
                                    <AiOutlineMail/>
                                    <span>{data?.data?.data[0].email}</span>
                                </a>
                            </li>
                        </div>

                        <li className={"header__top__list__item"} style={{ paddingRight: '10px', display: 'flex', alignItems: 'center' }}>
                            <SpeechHeaderButtonStyle 
                                onClick={handleToggleSpeech} 
                                className={isSpeechActive ? "active" : ""}
                            >
                                <FaVolumeUp />
                                <span className="tooltip-text">
                                    {localStorage.getItem("i18nextLng") === "ru" 
                                        ? "Голосовой помощник" 
                                        : localStorage.getItem("i18nextLng") === "en" 
                                            ? "Voice Assistant" 
                                            : "Ovozli yordamchi"}
                                </span>
                            </SpeechHeaderButtonStyle>
                        </li>

                        <li className={"header__top__list__item"}>
                            <Guidelines/>
                        </li>

                        <div className="swiperLinks header__top__list__item right">
                            <Swiper
                                direction={'vertical'}
                                slidesPerView={1}
                                spaceBetween={1}
                                loop={true}
                                pagination={{
                                    clickable: true,
                                }}
                                autoplay={{
                                    delay: 3000,
                                    disableOnInteraction: false,
                                    pauseOnMouseEnter: true,
                                    reverseDirection: true,

                                }}
                                modules={[ Autoplay]}
                                className="mySwiper"
                                style={{
                                    height:"50px",
                                    width:"300px",
                                    }}>

                                <SwiperSlide>
                                    <SwiperFlag/>
                                </SwiperSlide>
                                <SwiperSlide>
                                  <Mesengers/>
                                </SwiperSlide>

                            </Swiper>
                        </div>


                        <li className={`header__top__list__item lang`}>
                            <LanguageSwitcher/>
                        </li>
                    </ul>
                </div>
            </div>
        </PageTopStyle>
    );
};

export default PageTop;
